/** Origen público canónico de la wiki (subdominio dedicado con SSL). */
export const WIKI_PUBLIC_ORIGIN = 'https://wiki.tnonetwork.com';

/** Ruta índice de la wiki (listado de manuales). */
export const WIKI_HOME_PATH = '/';

/** URL absoluta del índice de manuales. */
export const WIKI_HOME_URL = `${WIKI_PUBLIC_ORIGIN}/`;

/** Manual del operador audiovisual (contenido desde Academy Service). */
export const WIKI_MANUAL_OPERADOR_AUDIOVISUAL_PATH = '/wiki/operador-audiovisual';
export const WIKI_MANUAL_OPERADOR_AUDIOVISUAL_URL = `${WIKI_PUBLIC_ORIGIN}${WIKI_MANUAL_OPERADOR_AUDIOVISUAL_PATH}`;

/** Manual pautas en exteriores / locaciones fuera de cabina TNO. */
export const WIKI_MANUAL_PAUTAS_EXTERIORES_PATH = '/wiki/pautas-exteriores';
export const WIKI_MANUAL_PAUTAS_EXTERIORES_URL = `${WIKI_PUBLIC_ORIGIN}${WIKI_MANUAL_PAUTAS_EXTERIORES_PATH}`;

/** Manual único de subida de programas (YouTube, otras plataformas, sistema TNO). */
export const WIKI_MANUAL_SUBIDA_PROGRAMAS_PATH = '/wiki/subida-programas';
export const WIKI_MANUAL_SUBIDA_PROGRAMAS_URL = `${WIKI_PUBLIC_ORIGIN}${WIKI_MANUAL_SUBIDA_PROGRAMAS_PATH}`;

/** Manual de publicación de noticias TNO en Ghost. */
export const WIKI_MANUAL_PUBLICAR_NOTICIAS_TNO_PATH = '/wiki/publicar-noticias-tno';
export const WIKI_MANUAL_PUBLICAR_NOTICIAS_TNO_URL = `${WIKI_PUBLIC_ORIGIN}${WIKI_MANUAL_PUBLICAR_NOTICIAS_TNO_PATH}`;
